exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-reorder-component-v2 .ant-card-body{padding:12px}.cap-reorder-component-v2 .title-label{margin:0px 18px .571rem;text-align:center;width:144px;height:14px}.cap-reorder-component-v2 .card-component{width:180px;height:124px;display:flex}.cap-reorder-component-v2 .card-component .component-icon{padding:20px 54px 13px}.cap-reorder-component-v2 .card-component .component-channel{width:111px;text-align:center;margin-left:22px}\n", ""]);

// exports
